<template>
  <Overlay name="mobile-nav">
    <menu class="mobile-nav">
      <h3 class="mobile-nav__title">Menu</h3>
      <MobileNavLink v-for="link in navLinks" :key="link.label" v-bind="link" />

      <PageLink :to="$store.getters.overlayLink('contact')" class="button mobile-nav__contact">
        <Icon id="chat" />
        {{ $wp.navigation.contactLabel[$lang.current] }}
      </PageLink>

      <RouterLink v-for="{ lang, label } in langLinks" :key="lang" :to="$lang.switch(lang)" class="mobile-nav__lang">{{
        label
      }}</RouterLink>
    </menu>
  </Overlay>
</template>

<script>
import { MobileNavLink } from '@/components/partials'

export default {
  name: 'MobileNav',
  contentKey: 'settings',
  components: { MobileNavLink },
  computed: {
    navLinks() {
      const { links = [] } = this.$wp.navigation
      const { current = 'fr' } = this.$lang
      return links.map(({ label, anchors, to }) => ({ anchors, to: this.$lang.route(to), label: label[current] }))
    },
    langLinks() {
      const { list, current } = this.$lang
      return list
        .filter(lang => lang !== current)
        .map(lang => ({ lang, label: lang === 'en' ? 'English' : 'Français' }))
    }
  }
}
</script>
